import React from 'react';

import PropTypes from 'prop-types';
import { Body } from '@vds/typography';

const PriceInfo = ({ planPrice, strikeOffPrice }) => (
  <div style={{ display: 'flex', margin: '4px 0 8px 0' }}>
    {strikeOffPrice && (
      <span style={{ padding: '0 4px' }}>
        <Body strikethrough size="large" color="#6F7171">
          {planPrice}
        </Body>
      </span>
    )}
    <Body size="large" color="#000000">
      {strikeOffPrice || planPrice}
    </Body>
  </div>
);

PriceInfo.propTypes = {
  planPrice: PropTypes.string,
  strikeOffPrice: PropTypes.string,
};
export default PriceInfo;
